import i18n from '@/js/i18n';
import bingo from '@/services/api/bingo/bingo';

const state = {
  isSallesLoaded: false,
  salles: null,
  sallesLive: null,

  isGagnantsMajeursLoaded: false,
  gagnantsMajeurs: null,

  isGagnantsRecentsLoaded: false,
  gagnantsRecents: null,
};

const getters = {
  // Si idSalle n'est pas spécifié, on retourne toutes les salles (dont lobbyLink et msgDesactivation)
  getSalle: (state) => (idSalle) => {
    if (idSalle) {
      //   return state.salles ? state.salles[idSalle] : null;

      return state.salles
        ? state.salles.find(
            (unElement) => unElement.name === idSalle || unElement['@name'] === idSalle
          )
        : null;
    }
    return state.salles;
  },
  // Parcourir toutes les salles et retournée celle qui correspond au idSalleNyx
  getSalleByIdSalleNyx: (state) => (idSalleNyx) => {
    return state.salles.find((aSalle) => aSalle.idSalleNyx == idSalleNyx);
  },
  getSalleLive: (state) => (idSalle) => {
    return state.sallesLive ? state.sallesLive[idSalle] : null;
  },
  getGagnantsMajeurs: (state) => () => {
    return state.gagnantsMajeurs;
  },
  getGagnantsRecents: (state) => () => {
    return state.gagnantsRecents;
  },
};

const actions = {
  initSalles(context) {
    if (!state.isSallesLoaded) {
      context.commit('setSallesLoaded', true);
      bingo
        .getSalles(i18n.locale)
        .then(function (salles) {
          context.commit('setSalles', salles);
        })
        .catch((error) => console.log(error));
      context.dispatch('refreshSallesLive');
    }
  },
  refreshSallesLive(context) {
    // console.log("isIdle:", context.rootState.idleVue.isIdle);
    // Corrige problème appel récurrent par le service-worker
    if (window.location.href.indexOf('/bingo/') > -1 && !context.rootState.idleVue.isIdle) {
      bingo
        .getSallesLive(i18n.locale)
        .then(function (sallesLive) {
          context.commit('setSallesLive', sallesLive);
        })
        .catch((error) => console.log(error));
    }
    // Délai de raffaichissement: 30 sec en PO, 10 sec en DEV. 2 x cache busting de api/Bingo.js
    const timerSallesLive = setTimeout(
      function () {
        context.dispatch('refreshSallesLive');
      },
      process.env.NODE_ENV == 'production' ? 30000 : 10000
    );
  },

  initGagnantMajeurs(context) {
    if (!state.isGagnantsMajeursLoaded) {
      context.commit('setGagnantsMajeursLoaded', true);
      bingo
        .getGagnants(bingo.MAJEUR)
        .then(function (gagnantMajeurs) {
          context.commit('setGagnantsMajeurs', gagnantMajeurs);
        })
        .catch((error) => console.log(error));
    }
  },
  initGagnantRecents(context) {
    if (!state.isGagnantsRecentsLoaded) {
      context.commit('setGagnantsRecentsLoaded', true);
      bingo
        .getGagnants(bingo.RECENT)
        .then(function (gagnantRecents) {
          context.commit('setGagnantsRecents', gagnantRecents);
        })
        .catch((error) => console.log(error));
    }
  },
};

const mutations = {
  setSallesLoaded(state, isSallesLoaded) {
    state.isSallesLoaded = isSallesLoaded;
  },
  setSalles(state, salles) {
    state.salles = salles;
  },
  setSallesLive(state, sallesLive) {
    state.sallesLive = sallesLive;
  },

  setGagnantsMajeursLoaded(state, isGagnantsMajeursLoaded) {
    state.isGagnantsMajeursLoaded = isGagnantsMajeursLoaded;
  },
  setGagnantsMajeurs(state, gagnantsMajeurs) {
    state.gagnantsMajeurs = gagnantsMajeurs;
  },
  setGagnantsRecentsLoaded(state, isGagnantsRecentsLoaded) {
    state.isGagnantsRecentsLoaded = isGagnantsRecentsLoaded;
  },
  setGagnantsRecents(state, gagnantsRecents) {
    state.gagnantsRecents = gagnantsRecents;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
